import { Variant, Work } from "./WorksDatabase";

export interface CartLineItem {
  work: Work;
  variant: Variant;
  qty: number;
}

export type CartShipping = { type: "pickup"; cost: 0 } | { type: "ship"; cost: number };

export interface Cart {
  items: CartLineItem[];
  email: string;
  instructions: string;
  shipping: CartShipping;
}

export function getCart(): Cart {
  const sval = global.window?.sessionStorage.getItem("mc_cart");
  if (!sval) {
    return {
      items: [],
      instructions: "",
      email: "",
      shipping: { type: "pickup", cost: 0 },
    };
  }
  return JSON.parse(sval) as Cart;
}

export function saveCart(cart: Cart) {
  window.sessionStorage.setItem("mc_cart", JSON.stringify(cart));
}

export function addToCart(work: Work, variant: Variant, qty: number) {
  const cart = getCart();

  let li = cart.items.find((item) => item.work.id === work.id && item.variant.name === variant.name);

  if (li) {
    li.qty += qty;
  } else {
    li = { work, variant, qty };
    cart.items.push(li);
  }
  if (li.qty < 0) {
    throw new Error("Invalid cart");
  }
  saveCart(cart);
  return cart;
}
